import { useMutation, UseMutationResult, useQueryClient } from 'react-query';

import { getTokenWithType } from './useAuth';

import { addContact, contactItem as updateContact } from 'utils/urls';

import { ContactList } from 'types/contacts';
import { ErrorModal } from 'types/modalTypes';

export async function postContact(params: ContactList): Promise<TResult> {
  const { Id, AccountId } = params;
  const response = await fetch(
    Id === 0 ? addContact(AccountId) : updateContact(AccountId, Id),
    {
      method: Id === 0 ? 'POST' : 'PUT',
      headers: {
        Authorization: getTokenWithType(),
        'content-type': 'application/json',
      },
      body: JSON.stringify(params),
    },
  );
  return response.json();
}

type TError = ErrorModal;

type TResult = {
  Data: ContactList;
  IsSuccess: boolean;
  StatusCode: number;
} & ErrorModal;

type TVariables = ContactList;

type TSnapshot = unknown;

function useSaveContact(): UseMutationResult<
  TResult,
  TError,
  TVariables,
  TSnapshot
> {
  const queryClient = useQueryClient();
  return useMutation(async (params: ContactList) => {
    const newContact = await postContact(params);

    if (newContact.StatusCode === 200) {
      queryClient.invalidateQueries(['contact_list']);
      queryClient.invalidateQueries([
        'get_contact_info',
        params.AccountId,
        params.Id,
      ]);
    } else if (newContact.Errors) {
      throw newContact;
    }
    return newContact;
  });
}

export { useSaveContact };
